import { userRoles } from '@constants/common';
import { mobileUserStore } from '@mobileStore/user';
import { intersection } from 'lodash';

const getRoles = () => mobileUserStore.user.roles ?? [];

const hasRole = (role: string) => getRoles().includes(role);

export const mobileIsAdmin = () =>
  hasRole(userRoles.ADMIN) || hasRole(userRoles.ADMIN_LITE);

export const mobileIsSuperAdmin = () => hasRole(userRoles.SUPER_ADMIN);

export const mobileIsManager = () => hasRole(userRoles.MANAGER);

export const mobileIsRecruiter = () => hasRole(userRoles.RECRUITER);

export const mobileIsAccounting = () => hasRole(userRoles.ACCOUNTING);

export const mobileIsCarrierRelations = () =>
  hasRole(userRoles.CARRIER_RELATIONS);

export const mobileIsCollections = () => hasRole(userRoles.COLLECTIONS);

export const mobileIsCapacity = () => hasRole(userRoles.CAPACITY);

export const mobileUserHasRole = (role: string) => hasRole(role);

export const getMobileUserId = () => mobileUserStore.user.id;

export const mobileHasPermission = (permission: string) =>
  mobileUserStore.user.permissions?.includes(permission) ?? false;

export const mobileIsLeadership = () =>
  hasRole(userRoles.MANAGER) || hasRole(userRoles.SUPERVISOR);

export const mobileIsSupervisor = () => hasRole(userRoles.SUPERVISOR);

export const mobileIsAgent = () => !mobileIsLeadership() && !mobileIsAdmin();

export const mobileIsReadonly = () =>
  intersection(getRoles(), [userRoles.ADMIN, userRoles.ADMIN_LITE]).length <= 0;

export const mobileIsLTLAdmin = () =>
  intersection(getRoles(), [
    userRoles.ADMIN,
    userRoles.ADMIN_LITE,
    userRoles.SUPER_ADMIN,
  ]).length > 0;
